import getAreaCodes from "./getAreaCodes.ts";
import getNumbers from "@/redux/slices/numbers/thunks/getNumbers";
import getInclusiveRemaining from "@/redux/slices/numbers/thunks/getInclusiveRemaining";

const thunks = [getAreaCodes, getNumbers, getInclusiveRemaining];

export default thunks;
